// extracted by mini-css-extract-plugin
export var promptCard = "PromptCard-module--promptCard--69742";
export var promptContent = "PromptCard-module--promptContent--812a7";
export var promptCopyButton = "PromptCard-module--promptCopyButton--fbfa5";
export var promptLabel = "PromptCard-module--promptLabel--01b5f";